import { type MCPServerInfo } from '../../types';

const BuildkiteServer: MCPServerInfo = {
  serverId: 'BUILDKITE',
  name: 'Buildkite',
  slug: 'buildkite',
  description:
    'Buildkite MCP Server - Connect to your CI/CD pipelines, builds, and jobs',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.buildkite.com/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default BuildkiteServer;
